'use client';

import { Box, Label, TextButton, Typography } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import Avatar from '../Avatar/Avatar';

import { useDeviceCheck } from '@/shared/hooks';

interface PersonalDataProfileProps {
  imgSrc?: string;
  name: string;
  rank?: number;
  career: number;
  role: string;
  openProfileEdit: () => void;
}

const PersonalDataProfile = ({
  imgSrc,
  name,
  rank,
  career,
  role,
  openProfileEdit,
}: PersonalDataProfileProps) => {
  const { isDesktop } = useDeviceCheck();

  return (
    <Box
      className={twJoin(
        'flex w-full items-center gap-4',
        'tablet:w-auto desktop:gap-6'
      )}
    >
      <Avatar size={isDesktop ? 'md' : 'sm'} src={imgSrc} variant="gradient" />
      <Box
        className={twJoin(
          'flex w-[calc(100%_-_64px)] flex-col gap-0.5',
          'tablet:w-auto desktop:gap-1'
        )}
      >
        <Box className={twJoin('flex items-center gap-1.5', 'desktop:gap-3')}>
          <Typography
            variant="subTitle1"
            className={twJoin(
              'truncate font-medium text-w-gray-900',
              'desktop:typo-title3'
            )}
            data-testid="personal-data-profile-name"
          >
            {name}님
          </Typography>
          {rank && (
            <Label.Root type="filled" size="sm" className="h-[22px]">
              <Label.Text className="whitespace-nowrap">{`상위 ${rank}%`}</Label.Text>
            </Label.Root>
          )}
        </Box>
        <Box className="flex gap-2">
          <Typography
            variant="body2"
            className="text-w-gray-600"
            data-testid="personal-data-profile-career-role"
          >
            {`${career}년차 · ${role}`}
          </Typography>
          <TextButton
            text="수정"
            isTextSmall
            leadingIcon="small_edit"
            onClick={openProfileEdit}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PersonalDataProfile;
